import { complement, darken, desaturate, saturate } from "polished";
var mapColor = function(theme) {
    var color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
    return ({
        green: theme.color.primary,
        grey: darken(0.46, desaturate(0.32, theme.color.primaryHighlight)),
        default: darken(0.84, theme.color.natural10),
        white: theme.color.natural0,
        orange: theme.color.natural70,
        error: darken(0.3, saturate(0.51, complement(theme.color.secondaryHighlight))),
        current: "currentcolor"
    })[color];
};
export { mapColor };
